export default __webpack_public_path__ + "static/media/Watcher's Serpentweave.6188e484.jpg";